var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M512,256c0,141.385-114.615,256-256,256C125.555,512,17.899,414.438,2.027,288.298 C0.69,277.723,0,266.94,0,256c0-20.041,2.299-39.549,6.656-58.264C33.029,84.428,134.656,0,256,0 c121.041,0,222.469,84.01,249.135,196.901c3.5,14.764,5.705,30.02,6.51,45.641C511.885,247.003,512,251.486,512,256z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3B8739"
    },
    points: "243.195,276.559 243.195,210 185.553,176.721 127.912,210 127.912,276.559 185.553,309.838  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M470.204,266.459l37.564,21.692l-37.564,21.692l-57.637-33.28v-66.56l57.637-33.28l34.931,20.177 c3.5,14.764,5.705,30.02,6.51,45.641l-21.358,12.33v-23.186l-20.083-11.588l-20.083,11.588v23.186L470.204,266.459z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#66A060"
    },
    points: "481.392,249.74 481.392,236.82 470.203,230.36 459.013,236.82 459.013,249.74  470.203,256.201 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M100.686,210.004v87.771l-38.442-21.932v-44.993L43.05,219.763l-19.195,11.086v44.993L2.027,288.298 C0.69,277.723,0,266.94,0,256c0-20.041,2.299-39.549,6.656-58.264l36.394-21.013L100.686,210.004z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.906,
    y: 210.001,
    transform: "matrix(0.5 0.866 -0.866 0.5 303.4564 -39.0495)",
    style: {
      fill: "#6DA75D"
    },
    width: 115.281,
    height: 66.557
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#55A344"
    },
    points: "127.912,276.559 147.704,244.283 127.912,210 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#639D57"
    },
    points: "223.979,243.277 243.195,210 185.553,176.721 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M346.551,99.579v88.304l-19.32-11.16l-57.647,33.28v66.56l57.647,33.28l57.637-33.28V120.09 L346.551,99.579z M346.446,254.37l-19.216,11.097l-19.216-11.097v-22.183l19.216-11.097l19.216,11.097V254.37z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66A060"
    },
    d: "M282.149,358.717c0,0-1.132-9.729-11.539-9.729c-10.408,0-17.534,1.357-17.534,7.127 s20.25,5.77,27.943,8.032c7.693,2.262,14.48,8.145,11.086,18.553c-3.394,10.408-13.802,11.539-29.866,11.539 s-19.685-13.35-19.685-18.553h9.05c0,0-1.132,8.145,9.502,9.502c10.634,1.357,20.802,2.121,22.173-6.108 c1.81-10.861-34.391-5.43-37.559-16.064c-2.676-8.985-1.132-20.815,16.969-22.626c18.101-1.811,28.056,6.181,28.056,18.101 L282.149,358.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66A060"
    },
    d: "M194.723,401.131l20.008,11.551c10.053,5.804,22.619-1.451,22.619-13.059v-20.242v-37.253h-8.155 v55.227c0,6.339-6.862,10.302-12.353,7.131l-13.965-8.062v-58.94l51.043-29.467l51.043,29.467v58.94l-51.043,29.467l-14.704-8.489 l-9.602,3.872l24.305,14.033l59.198-34.179v-68.351L253.92,298.6l-59.198,34.179v68.352H194.723z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.99ef8ff93a529f2d79b6ebce3139e2c2.svg";
export { ForwardRef as ReactComponent };